(() => {
  const money = (cents, currency) => {
    try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency }).format((Number(cents) || 0) / 100); }
    catch (_) { return `$${((Number(cents) || 0) / 100).toFixed(2)}`; }
  };

  const init = (root) => {
    if (!root || root.dataset.cxReady === 'true') return;
    root.dataset.cxReady = 'true';
    const currency = root.dataset.currency || 'USD';
    const addLabel = root.dataset.addLabel || '';
    const soldOutLabel = root.dataset.soldOutLabel || '';
    const tryAgainLabel = root.dataset.tryAgainLabel || '';
    const noRecommendationsLabel = root.dataset.noRecommendationsLabel || '';
    const accessoriesUnavailableLabel = root.dataset.accessoriesUnavailableLabel || '';
    const form = root.querySelector('.cx-product-form');
    const mainVariantInput = root.querySelector('[data-main-variant-input]');
    const price = root.querySelector('[data-current-price]');
    const compare = root.querySelector('[data-compare-price]');
    const compareWrap = root.querySelector('[data-msrp-wrap]');
    const compareLabel = root.querySelector('[data-msrp-label]');
    const savedBadge = root.querySelector('[data-saved-badge]');
    const savedAmount = root.querySelector('[data-saved-amount]');
    const paymentButton = root.querySelector('[data-payment-button]');
    const mobileBuybar = root.querySelector('[data-mobile-buybar]');
    const mobileBuybarPrice = root.querySelector('[data-mobile-buybar-price]');
    const mobileAddButton = root.querySelector('[data-mobile-add-to-cart]');
    const mobileAddLabel = root.querySelector('[data-mobile-add-label]');
    const mainAddButton = root.querySelector('[data-add-to-cart]');
    const packagePreview = root.querySelector('[data-package-gallery-preview]');
    const packagePreviewImage = root.querySelector('[data-package-gallery-image]');

    const hidePackagePreview = () => {
      if (!packagePreview) return;
      packagePreview.hidden = true;
      packagePreview.classList.remove('is-loaded');
      packagePreview.closest('[data-cx-gallery]')?.classList.remove('is-package-preview');
    };

    const showPackagePreview = (card, variant) => {
      if (!packagePreview || !packagePreviewImage || !card || card.dataset.packageStandalone === 'true') {
        hidePackagePreview();
        return;
      }
      const variantImage = variant?.featured_media?.preview_image || variant?.featured_image;
      const imageUrl = variantImage?.src || variantImage?.url || card.dataset.packageImageUrl || '';
      if (!imageUrl) {
        hidePackagePreview();
        return;
      }
      packagePreview.classList.remove('is-loaded');
      packagePreview.hidden = false;
      packagePreview.closest('[data-cx-gallery]')?.classList.add('is-package-preview');
      packagePreviewImage.alt = variantImage?.alt || card.dataset.packageImageAlt || '';
      if (packagePreviewImage.src === imageUrl) {
        packagePreview.classList.add('is-loaded');
        return;
      }
      packagePreviewImage.onload = () => packagePreview.classList.add('is-loaded');
      packagePreviewImage.onerror = hidePackagePreview;
      packagePreviewImage.src = imageUrl;
    };

    const setGallery = (id) => {
      hidePackagePreview();
      root.querySelectorAll('[data-media-id]').forEach((el) => {
        if (el.matches('.cx-gallery__slide,.cx-gallery__thumb,.cx-gallery__video-dock')) el.classList.toggle('is-active', el.dataset.mediaId === id);
      });
      const activeSlide = root.querySelector(`.cx-gallery__slide[data-media-id="${id}"]`);
      const activeType = activeSlide?.dataset.mediaType;
      root.querySelectorAll('[data-external-video-frame]').forEach((frame) => {
        const frameSlide = frame.closest('.cx-gallery__slide');
        const shell = frame.closest('[data-external-video-shell]');
        const isCurrent = frameSlide === activeSlide;
        if (isCurrent && !frame.src && frame.dataset.videoSrc) {
          frame.src = frame.dataset.videoSrc;
          frame.addEventListener('load', () => shell?.classList.add('is-loaded'), { once: true });
        } else if (frame.src && frame.contentWindow) {
          frame.contentWindow.postMessage(JSON.stringify({
            event: 'command',
            func: isCurrent ? 'playVideo' : 'pauseVideo',
            args: []
          }), '*');
        }
      });
      const currentIndex = [...root.querySelectorAll('.cx-gallery__slide[data-media-id]')].findIndex((slide) => slide.dataset.mediaId === id);
      const counter = root.querySelector('[data-gallery-current]');
      if (counter && currentIndex >= 0) counter.textContent = String(currentIndex + 1);
      root.querySelectorAll('[data-gallery-mode]').forEach((button) => {
        const shouldActivate = button.dataset.galleryMode === 'video'
          ? activeType === 'video' || activeType === 'external_video'
          : activeType !== 'video' && activeType !== 'external_video';
        button.classList.toggle('is-active', shouldActivate);
      });
      root.querySelectorAll('.cx-gallery__slide video').forEach((video) => {
        if (video.closest('.cx-gallery__slide')?.classList.contains('is-active')) return;
        video.pause();
      });
    };
    root.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => thumb.addEventListener('click', () => setGallery(thumb.dataset.mediaId)));
    const mediaIds = [...root.querySelectorAll('.cx-gallery__slide[data-media-id]')].map((slide) => slide.dataset.mediaId);
    const moveMainGallery = (direction) => {
      if (!mediaIds.length) return;
      const activeId = root.querySelector('.cx-gallery__slide.is-active')?.dataset.mediaId;
      const currentIndex = Math.max(0, mediaIds.indexOf(activeId));
      const nextIndex = (currentIndex + direction + mediaIds.length) % mediaIds.length;
      setGallery(mediaIds[nextIndex]);
      root.querySelector(`[data-gallery-thumb][data-media-id="${mediaIds[nextIndex]}"]`)?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    };
    root.querySelector('[data-gallery-main-prev]')?.addEventListener('click', () => moveMainGallery(-1));
    root.querySelector('[data-gallery-main-next]')?.addEventListener('click', () => moveMainGallery(1));

    const galleryStage = root.querySelector('.cx-gallery__stage');
    let gallerySwipe = null;
    const resetGallerySwipe = () => {
      if (gallerySwipe && galleryStage?.hasPointerCapture?.(gallerySwipe.pointerId)) {
        galleryStage.releasePointerCapture(gallerySwipe.pointerId);
      }
      gallerySwipe = null;
      galleryStage?.classList.remove('is-swiping');
    };
    galleryStage?.addEventListener('pointerdown', (event) => {
      if (!event.isPrimary || !window.matchMedia('(max-width: 749px)').matches) return;
      if (event.target.closest('button,video,iframe,model-viewer,[data-external-video-shell]')) return;
      gallerySwipe = {
        pointerId: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        moved: false
      };
      galleryStage.setPointerCapture?.(event.pointerId);
    });
    galleryStage?.addEventListener('pointermove', (event) => {
      if (!gallerySwipe || gallerySwipe.pointerId !== event.pointerId) return;
      const deltaX = event.clientX - gallerySwipe.startX;
      const deltaY = event.clientY - gallerySwipe.startY;
      if (Math.abs(deltaX) > 10 && Math.abs(deltaX) > Math.abs(deltaY)) {
        gallerySwipe.moved = true;
        galleryStage.classList.add('is-swiping');
      }
    });
    galleryStage?.addEventListener('pointerup', (event) => {
      if (!gallerySwipe || gallerySwipe.pointerId !== event.pointerId) return;
      const deltaX = event.clientX - gallerySwipe.startX;
      const deltaY = event.clientY - gallerySwipe.startY;
      const threshold = Math.max(44, galleryStage.clientWidth * 0.1);
      const shouldMove = gallerySwipe.moved
        && Math.abs(deltaX) >= threshold
        && Math.abs(deltaX) > Math.abs(deltaY) * 1.15;
      resetGallerySwipe();
      if (shouldMove) moveMainGallery(deltaX < 0 ? 1 : -1);
    });
    galleryStage?.addEventListener('pointercancel', resetGallerySwipe);
    root.querySelectorAll('[data-gallery-mode]').forEach((button) => button.addEventListener('click', () => {
      if (button.dataset.galleryMode === 'video') {
        const videoId = button.dataset.videoMediaId;
        if (videoId) setGallery(videoId);
        return;
      }
      const firstFeature = root.querySelector('.cx-gallery__slide[data-media-type="image"],.cx-gallery__slide[data-media-type="model"]');
      if (firstFeature?.dataset.mediaId) setGallery(firstFeature.dataset.mediaId);
    }));
    const initialMedia = root.querySelector('.cx-gallery__slide.is-active[data-media-id]');
    if (initialMedia?.dataset.mediaId) setGallery(initialMedia.dataset.mediaId);
    const rail = root.querySelector('[data-gallery-rail]');
    root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => rail?.scrollBy({ left: -220, behavior: 'smooth' }));
    root.querySelector('[data-gallery-next]')?.addEventListener('click', () => rail?.scrollBy({ left: 220, behavior: 'smooth' }));

    const videoPreviewOnIntent = root.dataset.videoPreviewOnIntent === 'true';
    const canStartVideoPreview = (dock) => !videoPreviewOnIntent || (!document.hidden && !dock.classList.contains('is-active') && dock.matches(':hover, :focus-visible'));
    const startVideoThumbnail = (dock) => {
      if (!dock || dock.dataset.videoStarted === 'true') return;
      if (!canStartVideoPreview(dock)) return;
      dock.dataset.videoStarted = 'true';
      const nativeVideo = dock.querySelector('[data-video-thumb-native]');
      if (nativeVideo) {
        nativeVideo.play().then(() => dock.classList.add('is-playing')).catch(() => {});
        return;
      }
      const frame = dock.querySelector('[data-video-thumb-frame]');
      if (!frame || !frame.dataset.videoSrc) return;
      const loadFrame = () => {
        if (!canStartVideoPreview(dock)) {
          dock.dataset.videoStarted = 'false';
          return;
        }
        frame.src = frame.dataset.videoSrc;
        frame.addEventListener('load', () => dock.classList.add('is-playing'), { once: true });
      };
      if (videoPreviewOnIntent) loadFrame();
      else if ('requestIdleCallback' in window) window.requestIdleCallback(loadFrame, { timeout: 1200 });
      else window.setTimeout(loadFrame, 350);
    };
    const videoThumbs = root.querySelectorAll('[data-video-thumb]');
    if (videoPreviewOnIntent) {
      videoThumbs.forEach((dock) => {
        let intentTimer = null;
        const cancelPreview = () => { window.clearTimeout(intentTimer); intentTimer = null; };
        const queuePreview = () => {
          cancelPreview();
          intentTimer = window.setTimeout(() => startVideoThumbnail(dock), 300);
        };
        dock.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse' || event.pointerType === 'pen') queuePreview();
        });
        dock.addEventListener('pointerleave', cancelPreview);
        dock.addEventListener('focusin', () => {
          if (dock.matches(':focus-visible')) queuePreview();
        });
        dock.addEventListener('focusout', cancelPreview);
        dock.addEventListener('click', cancelPreview);
      });
    } else if ('IntersectionObserver' in window) {
      const videoThumbObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          startVideoThumbnail(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '120px 0px', threshold: 0.15 });
      videoThumbs.forEach((dock) => videoThumbObserver.observe(dock));
    } else {
      videoThumbs.forEach(startVideoThumbnail);
    }

    const updatePrice = (variant) => {
      if (!variant) return;
      if (price) price.textContent = money(variant.price, currency);
      if (mobileBuybarPrice) mobileBuybarPrice.textContent = money(variant.price, currency);
      const compareValue = Number(variant.compare_at_price || 0);
      const currentValue = Number(variant.price || 0);
      const onSale = compareValue > currentValue;
      if (compare) compare.textContent = money(compareValue, currency);
      if (compareWrap) compareWrap.hidden = !onSale;
      if (compareLabel) compareLabel.hidden = !onSale;
      if (savedBadge) savedBadge.hidden = !onSale;
      if (savedAmount) savedAmount.textContent = onSale ? money(compareValue - currentValue, currency) : '';
      const button = root.querySelector('[data-add-to-cart]');
      if (button) button.disabled = variant.available === false;
      const label = root.querySelector('[data-add-label]');
      if (label) label.textContent = variant.available === false ? soldOutLabel : addLabel;
      if (mobileAddButton) mobileAddButton.disabled = variant.available === false;
      if (mobileAddLabel) mobileAddLabel.textContent = variant.available === false ? soldOutLabel : addLabel;
    };

    const packageVariants = (card) => {
      try { return JSON.parse(card.querySelector('[data-package-variants]')?.textContent || '[]'); }
      catch (_) { return []; }
    };

    const selectPackage = (card, selectedVariant) => {
      root.querySelectorAll('[data-package]').forEach((item) => {
        const active = item === card;
        item.classList.toggle('is-selected', active);
        item.setAttribute('aria-checked', active ? 'true' : 'false');
      });
      const chosen = [...card.querySelectorAll('[data-package-option]')].map((input) => input.value);
      const variantData = selectedVariant
        || packageVariants(card).find((item) => String(item.id) === String(card.dataset.variantId) && (!chosen.length || item.options.every((value, index) => value === chosen[index])));
      if (!variantData) {
        if (mainVariantInput) mainVariantInput.value = '';
        if (mainAddButton) mainAddButton.disabled = true;
        const label = root.querySelector('[data-add-label]');
        if (label) label.textContent = root.dataset.unavailableLabel || soldOutLabel;
        syncPayment();
        return;
      }
      const variant = {
        id: Number(card.dataset.variantId),
        price: Number(card.dataset.price),
        compare_at_price: Number(card.dataset.comparePrice || 0),
        available: variantData.available !== false
      };
      if (mainVariantInput) mainVariantInput.value = String(variant.id);
      mainVariantInput?.dispatchEvent(new Event('change', { bubbles: true }));
      updatePrice(variant);
      showPackagePreview(card, variantData);
      syncPayment();
    };

    root.querySelectorAll('[data-package]').forEach((card) => {
      card.addEventListener('click', (event) => {
        if (event.target.closest('select,[data-package-includes]')) return;
        selectPackage(card);
      });
      card.addEventListener('keydown', (event) => {
        if (event.target.closest('select,[data-package-includes]')) return;
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); selectPackage(card); }
      });
      card.querySelectorAll('[data-package-option]').forEach((select) => select.addEventListener('change', () => {
        const variants = packageVariants(card);
        const chosen = [...card.querySelectorAll('[data-package-option]')].map((input) => input.value);
        const variant = variants.find((item) => item.options.every((value, index) => value === chosen[index]));
        if (!variant) { selectPackage(card); return; }
        card.dataset.variantId = variant.id;
        card.dataset.price = variant.price;
        card.dataset.comparePrice = variant.compare_at_price || 0;
        card.dataset.available = variant.available ? 'true' : 'false';
        card.querySelector('[data-package-price]').textContent = money(variant.price, currency);
        const packageCompare = card.querySelector('[data-package-compare]');
        if (packageCompare) packageCompare.textContent = money(variant.compare_at_price || 0, currency);
        selectPackage(card, variant);
      }));
    });

    const qty = root.querySelector('[data-qty-input]');
    root.querySelector('[data-qty-minus]')?.addEventListener('click', () => { qty.value = Math.max(1, Number(qty.value || 1) - 1); qty.dispatchEvent(new Event('change', { bubbles: true })); });
    root.querySelector('[data-qty-plus]')?.addEventListener('click', () => { qty.value = Math.max(1, Number(qty.value || 1) + 1); qty.dispatchEvent(new Event('change', { bubbles: true })); });

    const addonHost = root.querySelector('[data-cx-addons]');
    const loadAddons = () => {
      if (!addonHost || addonHost.dataset.loaded === 'true') return;
      addonHost.dataset.loaded = 'true';
      const url = `${window.Shopify?.routes?.root || '/'}recommendations/products?section_id=${encodeURIComponent(root.dataset.sectionId)}&product_id=${encodeURIComponent(root.dataset.productId)}&limit=4&intent=complementary`;
      fetch(url).then((response) => response.text()).then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const response = doc.querySelector('.cx-recommendation-response');
        addonHost.querySelector('.cx-addons__loading')?.replaceWith(response || document.createTextNode(noRecommendationsLabel));
        addonHost.querySelectorAll('[data-addon-select]').forEach((select) => select.addEventListener('change', () => {
          const card = select.closest('[data-addon-card]');
          const option = select.selectedOptions[0];
          const check = card?.querySelector('[data-addon-id]');
          if (check) { check.dataset.addonId = option.value; check.dataset.addonPrice = option.dataset.price || '0'; }
        }));
      }).catch(() => {
        const loading = addonHost.querySelector('.cx-addons__loading');
        if (loading) loading.textContent = accessoriesUnavailableLabel;
      });
    };
    if (addonHost && 'IntersectionObserver' in window) {
      const addonObserver = new IntersectionObserver((entries, observer) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        loadAddons();
      }, { rootMargin: '600px 0px' });
      addonObserver.observe(addonHost);
    } else if (addonHost) {
      window.setTimeout(loadAddons, 1200);
    }

    function syncPayment() {
      const hasExtra = !!root.querySelector('[data-addon-id]:checked,[data-warranty-id]:checked');
      const packageCard = root.querySelector('[data-package].is-selected');
      const hasBundle = packageCard && packageCard.dataset.packageStandalone !== 'true';
      if (paymentButton) paymentButton.hidden = (root.hasAttribute('data-cv-package-tools') && mainAddButton?.disabled) || hasExtra || hasBundle || !mainVariantInput?.value || !qty?.checkValidity();
    }
    root.addEventListener('change', syncPayment);
    root.addEventListener('input', syncPayment);
    syncPayment();

    mobileAddButton?.addEventListener('click', () => {
      if (!form || !mainAddButton || mainAddButton.disabled) return;
      form.requestSubmit(mainAddButton);
    });
    if (mainAddButton && mobileAddButton) {
      const syncMobileButton = () => {
        mobileAddButton.disabled = mainAddButton.disabled;
        mobileAddButton.setAttribute('aria-busy', mainAddButton.getAttribute('aria-busy') || 'false');
      };
      new MutationObserver(syncMobileButton).observe(mainAddButton, { attributes: true, attributeFilter: ['disabled', 'aria-busy'] });
      syncMobileButton();
    }
    const purchaseArea = root.querySelector('.cx-purchase');
    if (mobileBuybar && purchaseArea && 'IntersectionObserver' in window) {
      const purchaseObserver = new IntersectionObserver((entries) => {
        mobileBuybar.classList.toggle('is-hidden', entries.some((entry) => entry.isIntersecting));
      }, { threshold: 0.15 });
      purchaseObserver.observe(purchaseArea);
    }

    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = root.querySelector('[data-add-to-cart]');
      if (!mainVariantInput?.value || button?.disabled) return;
      if (qty && !qty.checkValidity()) { qty.reportValidity(); return; }
      const items = [{ id: Number(mainVariantInput.value), quantity: Math.max(1, Number(qty?.value || 1)) }];
      root.querySelectorAll('[data-addon-id]:checked').forEach((input) => items.push({ id: Number(input.dataset.addonId), quantity: 1 }));
      const warranty = root.querySelector('[data-warranty-id]:checked');
      if (warranty) items.push({ id: Number(warranty.dataset.warrantyId), quantity: 1 });
      button?.setAttribute('aria-busy', 'true');
      if (button) button.disabled = true;
      try {
        const response = await fetch(root.dataset.cartAddUrl || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) throw new Error('Cart request failed');
        window.location.assign(root.dataset.cartUrl || '/cart');
      } catch (_) {
        const label = root.querySelector('[data-add-label]');
        if (label) label.textContent = tryAgainLabel;
        if (button) button.disabled = false;
      } finally {
        button?.removeAttribute('aria-busy');
      }
    });


    if (root.hasAttribute('data-cv-package-tools')) {
      root.cvPackageSelect = (card, variant) => {
        card.dataset.variantId = variant ? String(variant.id) : '';
        card.dataset.price = variant ? String(variant.price) : '';
        card.dataset.comparePrice = variant ? String(variant.compare_at_price || 0) : '';
        selectPackage(card, variant);
        if (variant) {
          const cardPrice = card.querySelector('[data-package-price]');
          if (cardPrice) cardPrice.textContent = money(variant.price, currency);
          const cardCompare = card.querySelector('[data-package-compare]');
          if (cardCompare) {
            cardCompare.textContent = money(variant.compare_at_price || 0, currency);
            cardCompare.hidden = !(variant.compare_at_price > variant.price);
          }
          if (card.dataset.packageStandalone === 'true') {
            const id = variant.featured_media?.id || card.dataset.packageMediaId;
            if (id) setGallery(String(id));
          }
        } else {
          if (price) price.textContent = root.dataset.unavailableLabel || soldOutLabel;
          [compareWrap, compareLabel, savedBadge].forEach((node) => { if (node) node.hidden = true; });
        }
        if (mainAddButton?.getAttribute('aria-busy') === 'true') mainAddButton.disabled = true;
        if (paymentButton && !variant?.available) paymentButton.hidden = true;
      };
    }

    root.querySelectorAll('[data-campaign-end]').forEach((campaign) => {
      const end = new Date(campaign.dataset.campaignEnd).getTime();
      const boxes = campaign.querySelectorAll('[data-countdown] span');
      if (!Number.isFinite(end) || boxes.length < 4) return;
      const tick = () => {
        const seconds = Math.max(0, Math.floor((end - Date.now()) / 1000));
        const values = [Math.floor(seconds / 86400), Math.floor(seconds % 86400 / 3600), Math.floor(seconds % 3600 / 60), seconds % 60];
        boxes.forEach((box, index) => {
          const value = String(values[index]).padStart(2, '0');
          if (box.textContent !== value) box.textContent = value;
        });
      };
      tick(); window.setInterval(tick, 1000);
    });
  };

  const boot = () => document.querySelectorAll('.cx-product').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  document.addEventListener('shopify:section:load', boot);
})();

